import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import CardPicker from '../../../../../../packages/kiti/components/form/CardPicker'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'

const EditWidgetForm = () => {
  const { t } = useTranslation('common')

  return (
    <>
      <Col width="100%">
        <FormItem
          label={t('widgets.presentation')}
          path={['data', 'presentation']}
          Input={CardPicker}
          options={[
            { id: 'line', name: t('widgets.lines'), icon: 'RiLineChartLine' },
            { id: 'column', name: t('widgets.bars'), icon: 'RiBarChartFill' }
          ]}
          selectOnlyId
        />
      </Col>
    </>
  )
}

export default EditWidgetForm
